import React, { Component } from "react";
import {
  Select,
  Button,
  Popconfirm,
  Input,
  Form,
  Modal,
  Checkbox,
} from "antd";
import ColumnTable from "./table";

import PropTypes from "prop-types";
import { overtimeService } from "../../redux/services";

const { Option, OptGroup } = Select;

class EventColumnTable extends Component {
  formRef = React.createRef();
  columnTableRefs = [];

  static propTypes = {
    eventData: PropTypes.arrayOf(
      PropTypes.shape({
        eventType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        eventCode: PropTypes.string,
        separator: PropTypes.string,
        detailEnabled: PropTypes.bool,
        columns: PropTypes.array,
      })
    ),
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    eventData: [{ eventType: "", eventCode: "" }],
    readOnly: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      rows:
        Array.isArray(props.eventData) && props.eventData.length
          ? props.eventData.map((r) => {
            const eventTypeStr =
              r?.eventType === null || r?.eventType === undefined
                ? undefined
                : String(r.eventType);

            const cols = Array.isArray(r?.columns) ? r.columns : [];
            const autoDetail =
              eventTypeStr === "total_falta_dia" && cols.length > 0;

            return {
              eventType: eventTypeStr,
              eventCode: r?.eventCode ?? "",
              separator: r?.separator ?? "",
              detailEnabled: r?.detailEnabled ?? autoDetail,
              columns: cols,
            };
          })
          : [
            {
              eventType: undefined,
              eventCode: "",
              separator: "",
              detailEnabled: false,
              columns: [],
            },
          ],
      eventsTypes: [],
    };
  }

  componentDidMount() {
    this.getFormData().then(() => {
      // hidrata todas as linhas detalhadas que já vieram com columns
      this.hydrateAll();
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.eventData !== this.props.eventData) {
      const incoming = Array.isArray(this.props.eventData)
        ? this.props.eventData
        : [];

      const nextRows = incoming.length
        ? incoming.map((r) => {
          const eventTypeStr =
            r?.eventType === null || r?.eventType === undefined
              ? undefined
              : String(r.eventType);

          const cols = Array.isArray(r?.columns) ? r.columns : [];
          const autoDetail =
            eventTypeStr === "total_falta_dia" && cols.length > 0;

          return {
            eventType: eventTypeStr,
            eventCode: r?.eventCode ?? "",
            separator: r?.separator ?? "",
            detailEnabled: r?.detailEnabled ?? autoDetail,
            columns: cols,
          };
        })
        : [
          {
            eventType: undefined,
            eventCode: "",
            separator: "",
            detailEnabled: false,
            columns: [],
          },
        ];

      this.setState({ rows: nextRows }, () => {
        this.hydrateAll();
      });
    }
  }

  // tenta popular o ColumnTable (para componentes não-controlados)
  hydrateRow = (index) => {
    const ref = this.columnTableRefs[index];
    const row = this.state.rows[index];
    if (!ref || !row) return;

    const cols = Array.isArray(row.columns) ? row.columns : [];
    if (!cols.length) return;

    // tenta vários nomes de métodos comuns
    const candidates = [
      "setValue",
      "setData",
      "setRows",
      "load",
      "loadData",
      "replaceAll",
      "replaceData",
    ];

    for (const m of candidates) {
      if (typeof ref?.[m] === "function") {
        try {
          ref[m](cols);
          return;
        } catch (_) { }
      }
    }

    // se o componente for controlado por `value`, a prop já está sendo passada,
    // então só forçamos um re-render rápido (caso precise)
    this.forceUpdate();
  };

  hydrateAll = () => {
    // garanta que refs já foram ligados
    setTimeout(() => {
      this.state.rows.forEach((row, idx) => {
        if (row.eventType === "total_falta_dia" && row.detailEnabled) {
          this.hydrateRow(idx);
        }
      });
    }, 0);
  };

  // garante que transformamos qualquer retorno do ColumnTable em array de linhas
  ensureColumnsArray = (dataObject) => {
    if (!dataObject) return [];
    if (Array.isArray(dataObject)) return dataObject;
    if (Array.isArray(dataObject.columns)) return dataObject.columns;
    return [];
  };

  setColumnTableRef = (index, el) => {
    this.columnTableRefs[index] = el;
  };

  getPayload = async () => {
    const result = [];

    for (let i = 0; i < this.state.rows.length; i++) {
      const row = this.state.rows[i];
      const base = {
        eventType: row.eventType ?? undefined,
        eventCode: row.eventCode ?? "",
        separator: row.separator ?? "",
      };

      if (row.eventType === "total_falta_dia" && row.detailEnabled) {
        // Sempre tenta pegar o estado COMPLETO do filho primeiro
        let cols = [];
        const ref = this.columnTableRefs[i];
        if (ref?.getFormData) {
          try {
            const dataFromRef = await ref.getFormData();
            cols = this.ensureColumnsArray(dataFromRef);
          } catch (_) {
            // se falhar, cai para o que temos no pai
          }
        }
        if (!Array.isArray(cols) || cols.length === 0) {
          cols = Array.isArray(row.columns) ? row.columns : [];
        }

        result.push({ ...base, columns: cols });
      } else {
        result.push(base);
      }
    }

    return result;
  };

  getFormData = async () => {
    return this.getPayload();
  };

  toStr = (v) => (v === null || v === undefined ? undefined : String(v));

  handleAddRow = () => {
    this.setState((prev) => ({
      rows: [
        ...prev.rows,
        {
          eventType: undefined,
          eventCode: "",
          separator: "",
          detailEnabled: false,
          columns: [],
        },
      ],
    }));
  };

  handleRemoveRow = (index) => {
    this.setState(
      (prev) => ({
        rows: prev.rows.filter((_, i) => i !== index),
      }),
      () => {
        this.columnTableRefs.splice(index, 1);
      }
    );
  };

  handleEventTypeChange = (value, index) => {
    const nextVal = value != null ? String(value) : undefined;
    this.setState(
      (prev) => ({
        rows: prev.rows.map((row, i) => {
          if (i !== index) return row;

          if (nextVal !== "total_falta_dia") {
            return {
              ...row,
              eventType: nextVal,
              detailEnabled: false,
              columns: [],
            };
          }

          const hasCols = Array.isArray(row.columns) && row.columns.length > 0;
          return {
            ...row,
            eventType: nextVal,
            detailEnabled: hasCols ? true : row.detailEnabled,
          };
        }),
      }),
      () => {
        const row = this.state.rows[index];
        if (row?.eventType === "total_falta_dia" && row?.detailEnabled) {
          this.hydrateRow(index);
        }
      }
    );
  };

  handleEventCodeChange = (value, index) => {
    this.setState((prev) => ({
      rows: prev.rows.map((row, i) =>
        i === index ? { ...row, eventCode: value } : row
      ),
    }));
  };

  handleSeparatorChange = (index, event) => {
    const { value } = event.target;
    this.setState((prev) => ({
      rows: prev.rows.map((row, i) =>
        i === index ? { ...row, separator: value } : row
      ),
    }));
  };

  handleToggleDetail = (index, checked) => {
    this.setState(
      (prev) => ({
        rows: prev.rows.map((row, i) =>
          i === index
            ? {
              ...row,
              detailEnabled: checked,
              columns: checked ? row.columns : [],
            }
            : row
        ),
      }),
      () => {
        // ao marcar, tenta hidratar
        if (checked) this.hydrateRow(index);
      }
    );
  };

  handleColumnTableChange = async (index, dataObject) => {
    const ref = this.columnTableRefs[index];
    let columns = this.ensureColumnsArray(dataObject);

    // Sempre que o filho mudar, tente obter o "estado completo" dele
    if (ref?.getFormData) {
      try {
        const full = await ref.getFormData();
        const fullCols = this.ensureColumnsArray(full);
        if (fullCols?.length >= 0) {
          columns = fullCols; // prioriza a lista completa retornada pelo filho
        }
      } catch (_) {
        // se falhar, ficamos com o melhor que temos (dataObject normalizado)
      }
    }

    this.setState((prev) => ({
      rows: prev.rows.map((row, i) =>
        i === index ? { ...row, columns } : row
      ),
    }));
  };

  // ====== serviços ======
  getFormDataFromService = async () => {
    const [typeRes] = await Promise.all([overtimeService.getEventsTypes()]);
    const raw = Array.isArray(typeRes?.data) ? typeRes.data : [];

    let eventsTypes = [];
    if (raw.length && raw[0]?.name && raw[0]?.value && !raw[0]?.data) {
      eventsTypes = raw.map((i) => ({
        label: String(i.name),
        value: String(i.value),
      }));
    } else {
      eventsTypes = raw
        .filter((sec) => sec?.title && Array.isArray(sec?.data))
        .map((sec) => ({
          title: sec.title,
          options: (sec.data ?? [])
            .filter((i) => (i?.label || i?.name) && i?.value)
            .map((i) => ({
              value: String(i.value),
              label: String(i.label ?? i.name ?? String(i.value)),
            })),
        }));
    }
    return eventsTypes;
  };

  getFormData = async () => {
    const currentRows = Array.isArray(this.state?.rows) ? this.state.rows : [];
    try {
      const eventsTypes = await this.getFormDataFromService();
      const normalizedRows = currentRows.map((row) => {
        const eventTypeStr = this.toStr(row.eventType);
        const cols = Array.isArray(row.columns) ? row.columns : [];
        const autoDetail = eventTypeStr === "total_falta_dia" && cols.length > 0;

        return {
          ...row,
          eventType: eventTypeStr,
          eventCode: row.eventCode ?? "",
          separator: row.separator ?? "",
          detailEnabled: row.detailEnabled ?? autoDetail,
          columns: cols,
        };
      });

      this.setState({ eventsTypes, rows: normalizedRows }, () => {
        this.hydrateAll();
      });

      return this.getPayload();
    } catch (err) {
      Modal.error({ title: "Erro ao carregar dados", content: String(err) });
      return this.getPayload();
    }
  };

  renderReadOnly() {
    const { rows, eventsTypes } = this.state;

    const eventLabels = {};
    (eventsTypes ?? []).forEach((group) => {
      if (Array.isArray(group.options)) {
        group.options.forEach((option) => {
          eventLabels[String(option.value)] = option.label;
        });
      } else {
        eventLabels[String(group.value)] = group.label;
      }
    });

    return (
      <Form ref={this.formRef} component={false}>
        <div className="integration-table integration-table-events is-read-only">
          <div className="integration-table-header">
            <span>Coluna</span>
            <span>Código do evento</span>
          </div>

          {rows.map((row, index) => (
            <React.Fragment key={index}>
              <div className="integration-table-row">
                <span>{eventLabels[row.eventType] ?? (row.eventType || "-")}</span>
                <span>{row.eventCode || "-"}</span>
              </div>

              {row.eventType === "total_falta_dia" && row.detailEnabled && (
                <div className="integration-table-detail">
                  <span className="integration-table-detail-title">Evento detalhado</span>
                  <div className="integration-table-detail-columns">
                    <ColumnTable
                      key={`ct-${index}-${(row.columns || []).length}`}
                      ref={(el) => this.setColumnTableRef(index, el)}
                      eventData={row.columns}
                      readOnly
                      rowIndex={index}
                    />
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Form>
    );
  }

  render() {
    const { rows, eventsTypes } = this.state;
    const { readOnly } = this.props;

    if (readOnly) return this.renderReadOnly();

    const selectedValues = new Set(
      rows.map((r) => r.eventType).filter(Boolean)
    );

    return (
      <Form ref={this.formRef} component={false}>
        <div className={`integration-table integration-table-events ${readOnly ? "is-read-only" : ""}`}>
          <div className="integration-table-header">
            <span className="required">Coluna</span>
            <span className="required">Código do evento</span>
            {!readOnly && <span className="integration-table-actions">Ações</span>}
          </div>

          {rows.map((row, index) => (
            <React.Fragment key={index}>
              <div className="integration-table-row">
                <Select
                  showSearch
                  placeholder="Selecione uma coluna"
                  value={row.eventType ?? undefined}
                  onChange={(value) =>
                    this.handleEventTypeChange(value, index)
                  }
                  disabled={readOnly}
                  optionFilterProp="children"
                  optionLabelProp="children"
                  allowClear
                >
                  {(eventsTypes ?? []).map((group) => {
                    if (Array.isArray(group.options)) {
                      return (
                        <OptGroup key={group.title} label={group.title}>
                          {group.options.map((opt) => {
                            const val = String(opt.value);
                            const isTaken =
                              selectedValues.has(val) &&
                              row.eventType !== val;
                            return (
                              <Option key={val} value={val} disabled={isTaken}>
                                {opt.label}
                              </Option>
                            );
                          })}
                        </OptGroup>
                      );
                    }
                    const val = String(group.value);
                    const isTaken =
                      selectedValues.has(val) && row.eventType !== val;
                    return (
                      <Option key={val} value={val} disabled={isTaken}>
                        {group.label}
                      </Option>
                    );
                  })}
                </Select>

                <Input
                  placeholder="Código do evento"
                  value={row.eventCode}
                  maxLength={4}
                  onChange={(e) =>
                    this.handleEventCodeChange(e.target.value, index)
                  }
                  disabled={readOnly}
                />

                {!readOnly && (
                  <div className="integration-table-actions">
                    <Popconfirm
                      title="Deseja excluir essa linha?"
                      onConfirm={() => this.handleRemoveRow(index)}
                      okText="Sim"
                      cancelText="Não"
                    >
                      <Button
                        className="integration-table-remove"
                        danger
                        icon={<i className="fal fa-trash" />}
                      />
                    </Popconfirm>
                  </div>
                )}
              </div>

              {row.eventType === "total_falta_dia" && (
                <div className="integration-table-detail">
                  <Checkbox
                    disabled={readOnly}
                    checked={!!row.detailEnabled}
                    onChange={(e) =>
                      this.handleToggleDetail(index, e.target.checked)
                    }
                  >
                    Detalhar evento
                  </Checkbox>
                  {row.detailEnabled && (
                    <div className="integration-table-detail-columns">
                      <ColumnTable
                        // a key ajuda a forçar re-mount quando o conteúdo muda
                        key={`ct-${index}-${(row.columns || []).length}`}
                        ref={(el) => this.setColumnTableRef(index, el)}
                        eventData={row.columns}
                        readOnly={readOnly}
                        onChange={(dataObject) =>
                          this.handleColumnTableChange(index, dataObject)
                        }
                        rowIndex={index}
                      />
                    </div>
                  )}
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        {!readOnly && (
          <Button
            className="integration-table-add"
            type="secondary"
            onClick={this.handleAddRow}
            icon={<i className="far fa-plus" />}
          >
            Adicionar evento
          </Button>
        )}
      </Form>
    );
  }
}

export default EventColumnTable;
